import React from 'react';
import './footer.css';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';

const footerQuickLinks = [
    {
        display: 'Teams & Conditions',
        url: '#',
    },
    {
        display: 'Privacy Policy',
        url: '#',
    },
    {
        display: 'Return & Refund',
        url: '#',
    },
    {
        display: 'Payment Method',
        url: '#',
    },
];

const footerLinks = [
    {
        display: 'About Us',
        url: 'about',
    },
    {
        display: 'Menu',
        url: 'menu',
    },
    {
        display: 'Recipes',
        url: 'recipe',
    },
    {
        display: 'Contact',
        url: 'contact',
    },
];

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__top">
                <Container>
                    <Row>
                        <Col lg="4" md="6" sm="6">
                            <div className="nav__logo" title="Chef Food - Home">
                                <h2 className="d-flex align-item-center gap-1">
                                    <span>
                                        <i className="ri-restaurant-fill"></i>
                                    </span>
                                    Chef Food
                                </h2>
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Deleniti quisquam explicabo pariatur alias laborum illo.
                                </p>
                            </div>
                        </Col>

                        <Col lg="2" md="6" sm="6">
                            <h5 className="footer__link-title">Quick Link</h5>

                            <ListGroup>
                                {footerLinks.map((item, i) => (
                                    <ListGroupItem key={i} className="link__item">
                                        <Link to={item.url}>{item.display}</Link>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </Col>
                        <Col lg="3" md="6" sm="6">
                            <h5 className="footer__link-title">Info Link</h5>

                            <ListGroup>
                                {footerQuickLinks.map((item, i) => (
                                    <ListGroupItem key={i} className="link__item">
                                        <a href={item.url}>{item.display}</a>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </Col>

                        <Col lg="3" md="6" sm="6">
                            <h5 className="footer__link-title">Contact</h5>

                            <ListGroup>
                                <ListGroupItem className=" link__item d-flex align-item-center gap-3">
                                    <span>
                                        <i className="ri-map-pin-line"></i>
                                    </span>
                                    <span>Washington, DC</span>
                                </ListGroupItem>

                                <ListGroupItem className="link__item d-flex align-item-center gap-3">
                                    <span>
                                        <i className="ri-mail-line"></i>
                                    </span>
                                    <span>example@gmail.com</span>
                                </ListGroupItem>

                                <ListGroupItem className="link__item d-flex align-item-center gap-3">
                                    <span>
                                        <i className="ri-phone-line"></i>
                                    </span>
                                    <span>+880 123 456 789</span>
                                </ListGroupItem>
                            </ListGroup>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="footer__bottom">
                <Container>
                    <Row>
                        <Col>
                            <p>@copyright 2022, developer by RiiCute</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
};

export default Footer;
